import { render } from "./ModalBottomDynamic.html?vue&type=template&id=8ede75d2&scoped=true&ts=true"
import script from "./ModalBottomDynamic.vue?vue&type=script&lang=ts"
export * from "./ModalBottomDynamic.vue?vue&type=script&lang=ts"

import "./ModalBottomDynamic.scss?vue&type=style&index=0&id=8ede75d2&scoped=true&lang=scss"

import exportComponent from "/builds/customer/line/line-web-loyalty/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ede75d2"]])

export default __exports__